(() => {
  const STORAGE_PREFIX = "gs_collection_colour_";
  const BUSY_CLASS = "gs-swatch-busy";

  const parseMediaMap = (card) => {
    const el = card.querySelector(".product-card__variant-media-map");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const getColourValueFromSwatch = (swatch) => {
    const sr = swatch.querySelector(".sr-only");
    if (sr && sr.textContent) return sr.textContent.trim();

    const label = swatch.getAttribute("aria-label") || swatch.getAttribute("title") || "";
    const parts = label.split(" - ");
    return (parts[parts.length - 1] || "").trim();
  };

  const getProductKey = (card) => {
    const quickView = card.querySelector("quick-view[data-product-url]");
    const url = quickView ? quickView.getAttribute("data-product-url") : "";

    if (url) {
      const path = url.split("?")[0];
      const parts = path.split("/products/");
      const handle = parts.length > 1 ? parts[1].split("/")[0] : path;
      return STORAGE_PREFIX + handle;
    }

    const mediaLink = card.querySelector(".product-card__media a.media[href]");
    if (mediaLink) {
      try {
        const u = new URL(mediaLink.getAttribute("href"), window.location.origin);
        const p = u.pathname.split("/products/");
        const handle = p.length > 1 ? p[1].split("/")[0] : u.pathname;
        return STORAGE_PREFIX + handle;
      } catch {
        // ignore
      }
    }

    return null;
  };

  const setStoredColour = (card, colour) => {
    const key = getProductKey(card);
    if (!key || !colour) return;
    try {
      sessionStorage.setItem(key, colour);
    } catch {
      // ignore
    }
  };

  const getStoredColour = (card) => {
    const key = getProductKey(card);
    if (!key) return null;
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  };

  const setImg = (img, src, alt) => {
    if (!img || !src) return;
    img.src = src;
    if (img.hasAttribute("srcset")) img.setAttribute("srcset", "");
    if (img.hasAttribute("sizes")) img.setAttribute("sizes", "");
    if (alt) img.setAttribute("alt", alt);
  };

  const refreshFlickity = (carouselEl) => {
    try {
      if (!window.Flickity || !carouselEl) return;
      const flkty = window.Flickity.data(carouselEl);
      if (!flkty) return;
      flkty.select(0, false, true);
      flkty.resize();
      flkty.reposition();
    } catch {
      // ignore
    }
  };

  const updateLinks = (card, realHref) => {
    if (!realHref || realHref === "#") return;

    const mediaAnchor = card.querySelector(".product-card__media a.media");
    if (mediaAnchor) mediaAnchor.setAttribute("href", realHref);

    const titleAnchor = card.querySelector("a.product-card__title");
    if (titleAnchor) titleAnchor.setAttribute("href", realHref);

    const quickViewEl = card.querySelector("quick-view[data-product-url]");
    if (quickViewEl) quickViewEl.setAttribute("data-product-url", realHref);
  };

  const applySelection = (card, swatch) => {
    const mediaMap = parseMediaMap(card);
    if (!mediaMap) return;

    const colour = getColourValueFromSwatch(swatch);
    if (!colour) return;

    const items = mediaMap[colour];
    if (!Array.isArray(items) || items.length === 0) return;

    const realHref = swatch.getAttribute("data-href") || swatch.getAttribute("href") || "";

    const carousel = card.querySelector(".product-card__carousel");
    const slideImgs = carousel ? carousel.querySelectorAll(".flickity-slider img") : [];

    slideImgs.forEach((img, idx) => {
      const item = items[idx];
      const cell = img.closest(".flickity-cell");

      if (item && item.src) {
        if (cell) cell.style.display = "";
        setImg(img, item.src, item.alt || colour);
      } else {
        if (cell) cell.style.display = "none";
      }
    });

    const mediaLink = card.querySelector(".product-card__media a.media");
    if (mediaLink) {
      const imgs = mediaLink.querySelectorAll("img");
      const mainImg = imgs.length ? imgs[imgs.length - 1] : null;
      if (mainImg) setImg(mainImg, items[0].src, items[0].alt || colour);
    }

    const dots = card.querySelector(".flickity-page-dots");
    if (dots) dots.style.display = items.length > 1 ? "" : "none";

    refreshFlickity(carousel);

    card.querySelectorAll(".color-swatch").forEach((a) => a.classList.remove("is-selected"));
    swatch.classList.add("is-selected");

    updateLinks(card, realHref);
    setStoredColour(card, colour);
  };

  const getSelectedSwatch = (card) => {
    return card.querySelector("a.color-swatch.is-selected") || null;
  };

  const applyStoredOrDefault = (card) => {
    const swatches = card.querySelectorAll("a.color-swatch");
    if (!swatches.length) return;

    const stored = getStoredColour(card);
    if (stored) {
      const match = Array.from(swatches).find((s) => getColourValueFromSwatch(s) === stored);
      if (match) {
        applySelection(card, match);
        return;
      }
    }

    applySelection(card, swatches[0]);
  };

  const initCards = () => {
    document.querySelectorAll(".product-card").forEach((card) => {
      applyStoredOrDefault(card);
    });
  };

  const handleSwatchClick = (e) => {
    const swatch = e.target.closest("a.color-swatch");
    if (!swatch) return;

    const card = swatch.closest(".product-card");
    if (!card) return;

    const realHref = swatch.getAttribute("data-href") || swatch.getAttribute("href") || "";

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    if (realHref === "#") return;
    if (card.classList.contains(BUSY_CLASS)) return;

    card.classList.add(BUSY_CLASS);
    try {
      applySelection(card, swatch);
    } finally {
      card.classList.remove(BUSY_CLASS);
    }
  };

  const handleCardNavigate = (e) => {
    const link = e.target.closest(".product-card__media a.media, a.product-card__title");
    if (!link) return;

    const card = link.closest(".product-card");
    if (!card) return;

    const selected = getSelectedSwatch(card);
    if (!selected) return;

    const colour = getColourValueFromSwatch(selected);
    if (colour) setStoredColour(card, colour);
  };

  document.addEventListener("click", handleSwatchClick, true);
  document.addEventListener("click", handleCardNavigate, true);

  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      const el = document.activeElement;
      if (el && el.matches && el.matches("a.color-swatch")) {
        handleSwatchClick(e);
      }
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCards);
  } else {
    initCards();
  }

  window.addEventListener("pageshow", () => {
    initCards();
  });
})();
